import { memo, useEffect, useState, useContext, useRef } from 'react';
import { Link } from "react-router-dom";
import TextTruncate from 'react-text-truncate';
import { useCookies } from 'react-cookie'

import '../css/options.css'

import { Img } from "../Elements";

export default function Cats({ data, onChange }) {

    const [val, setval] = useState(0);
    
    
    useEffect(() => {

        if (typeof onChange == 'function') {

            let post = {
                _id: data?._id,
                type: data?.type?.val,
                name: data?.name,
                price: Number(data?.price) || 0,
                val: data?.type?.val == "count" ? parseInt(val) : val,
            };

            onChange(post);
        }
        
    }, [val])
    
    return (
        <div className='productOptions'>
            
            {data?.type?.val == "count" && 
                <>
                    <span>{data?.name}: <b>({val})</b></span>
                    <div className='rangeBox'>
                        <input type="range" onChange={(e) => setval(e.target.value)} id="volume" name="volume" min={data?.values[0] || 0} max={data?.values[1] || 100} step="1" value={val} />
                    </div>
                </>
            }

            {data?.type?.val == "numbers" && 
                <>
                    <span>{data?.name}: {val != '0' && <b>({val})</b>}</span>
                    <div className='optionsTagsBox'>

                        {data?.values?.map((v, k) => {

                            return (
                                <a className={v == val ? "checked" : "none"} onClick={() => setval(v == val ? false : v)} key={k}>{v}</a>
                            );
                        })}
                        
                        
                    </div>
                </>
            }

            {data?.type?.val == "colors" && 
                <>
                    <span>{data?.name}:</span>
                    <div className='optionsColorsBox'>

                        {data?.values?.map((v, k) => {

                            return (
                                <a style={{background:v}} className={v == val ? "checked" : "none"} onClick={() => setval(v == val ? false : v)} key={k}></a>
                            );
                        })}
                        
                        
                    </div>
                </>
            }
            
        </div>
    );
}
